<template>
  <div class="index">
    <el-dialog :title="form1.name" :visible.sync="dialogFormVisible1" width="50%">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="today_time" label="时间" width="180">
        </el-table-column>
        <el-table-column :prop="form1.date" :label="form1.label" width="180">
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible1 = false">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="form.name" :visible.sync="dialogFormVisible" width="50%">
      <el-form :model="form">
        <el-form-item :label-width="formLabelWidth">
          <el-input type="textarea" :rows="8" v-model="form.text" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisibleChange">确 定</el-button>
      </div>
    </el-dialog>
    <dv-loading v-if="loading">Loading...</dv-loading>
    <div class="index-top">
      <div class="index-top-left">
        中联航四川分公司
      </div>
      <div class="index-top-center">
        数字化管理3.0
      </div>
      <div class="index-top-right">
        <el-button type="text" @click="logout" style="color: #FFFFFF; font-size: 16px;">退出登录</el-button>
  </div>
    </div>
    <div class="index-bottom">
      <div class="index-bottom-1">
        <div class="index-bottom-1-top">
          <div class="index-bottom-1-top-1 li">月运行情况（截至昨日）</div>
          <div class="index-bottom-1-top-2 li">
            <div class="index-bottom-1-top-2-li" @click="checkChange('离港正常', 'quit_data')">离港正常</div>
            <div class="index-bottom-1-top-2-li" @click="dialogChange('离港正常', 'quit_data')">{{ dataObj['quit_data'] }}
            </div>
            <div class="index-bottom-1-top-2-li" @click="checkChange('始发正常', 'initiating_data')">始发正常</div>
            <div class="index-bottom-1-top-2-li" style="border-right: none;"
              @click="dialogChange('始发正常', 'initiating_data')">{{ dataObj['initiating_data'] }}</div>
          </div>
          <div class="index-bottom-1-top-2 li">
            <div class="index-bottom-1-top-2-li" @click="checkChange('机场离港正常', 'air_quit_data')">机场离港正常</div>
            <div class="index-bottom-1-top-2-li" @click="dialogChange('机场离港正常', 'air_quit_data')">{{ dataObj['air_quit_data'] }}
            </div>
            <div class="index-bottom-1-top-2-li" @click="checkChange('机场始发正常', 'air_initiating_data')">机场始发正常</div>
            <div class="index-bottom-1-top-2-li" style="border-right: none;" 
            @click="dialogChange('机场始发正常', 'air_initiating_data')">{{ dataObj['air_initiating_data'] }}</div>
          </div>

          <div class="index-bottom-1-top-2 li">
            <div class="index-bottom-1-top-2-li" @click="checkChange('关舱门', 'hatch_data')">关舱门</div>
            <div class="index-bottom-1-top-2-li" @click="dialogChange('关舱门', 'hatch_data')">{{ dataObj['hatch_data'] }}
            </div>
            <div class="index-bottom-1-top-2-li" @click="checkChange('过站符合', 'miss_data')">过站符合</div>
            <div class="index-bottom-1-top-2-li" style="border-right: none;" 
            @click="dialogChange('过站符合', 'miss_data')">{{ dataObj['miss_data'] }}</div>
          </div>
          <div class="index-bottom-1-top-3 li">
            <div class="index-bottom-1-top-3-li" @click="checkChange('当日航班量', 'volume_data')">当日航班量</div>
            <div class="index-bottom-1-top-3-li" style="border-right: none;"
              @click="dialogChange('当日航班量', 'volume_data')">{{ dataObj['volume_data'] }}</div>
          </div>
          <div class="index-bottom-1-top-4 li">
            <div class="index-bottom-1-top-4-li" @click="checkChange('当日重点航班', 'volume_point_data')">当日重点航班</div>
            <div class="index-bottom-1-top-4-li" style="border-right: none;"
              @click="dialogChange('当日重点航班', 'volume_point_data')">{{ dataObj['volume_point_data'] }}</div>
          </div>
        </div>
        <div class="index-bottom-1-center">
          <div class="index-bottom-1-center-1 li">
            <div class="index-bottom-1-center-1-li-left" @click="checkChange('过夜飞机', 'aeroplane_data')">过夜飞机</div>
            <div class="index-bottom-1-center-1-li-right" style="border-right: none;"
              @click="dialogChange('过夜飞机', 'aeroplane_data')">{{ dataObj['aeroplane_data'] }}</div>
          </div>
          <div class="index-bottom-1-center-2 li">
            <div class="index-bottom-1-center-2-li" @click="checkChange('集团值班', 'clique_duty_data')" style="font-weight: bold; font-size: 18px; text-shadow: 1px 1px 2px rgba(0,0,0,0.3);">集团值班</div>
            <div class="index-bottom-1-center-2-li" style="font-weight: bold; font-size: 18px; text-shadow: 1px 1px 2px rgba(0,0,0,0.3);" @click="dialogChange('集团值班', 'clique_duty_data')">{{ dataObj['clique_duty_data'] }}</div>
            <div class="index-bottom-1-center-2-li" @click="checkChange('中联航值班', 'mlion_duty_data')" style="font-weight: bold; font-size: 18px; text-shadow: 1px 1px 2px rgba(0,0,0,0.3);">中联航值班</div>
            <div class="index-bottom-1-center-2-li" style="border-right: none; font-weight: bold; font-size: 18px; text-shadow: 1px 1px 2px rgba(0,0,0,0.3);" @click="dialogChange('中联航值班', 'mlion_duty_data')">{{ dataObj['mlion_duty_data'] }}</div>
          </div>
          <div class="index-bottom-1-center-2 li">
            <div class="index-bottom-1-center-2-li" @click="checkChange('东航川分', 'kawane_data')">东航川分</div>
            <div class="index-bottom-1-center-2-li" @click="dialogChange('东航川分', 'kawane_data')">{{
      dataObj['kawane_data'] }}</div>
            <div class="index-bottom-1-center-2-li" @click="checkChange('四川分公司总值班', 'head_duty_data')">川分值班</div>
            <div class="index-bottom-1-center-2-li" style="border-right: none;"
              @click="dialogChange('四川分公司总值班', 'head_duty_data')">{{ dataObj['head_duty_data'] }}</div>
          </div>
          <div class="index-bottom-1-center-2 li">
            <div class="index-bottom-1-center-2-li" @click="checkChange('运行经理', 'operations_manager_data')">运行经理</div>
            <div class="index-bottom-1-center-2-li" @click="dialogChange('运行经理', 'operations_manager_data')">{{
      dataObj['operations_manager_data'] }}</div>
            <div class="index-bottom-1-center-2-li" @click="checkChange('指挥长', 'commander_data')">指挥长</div>
            <div class="index-bottom-1-center-2-li" style="border-right: none;"
              @click="dialogChange('指挥长', 'commander_data')">{{ dataObj['commander_data'] }}</div>
          </div>
          <div class="index-bottom-1-center-2 li" style="border-bottom: 5px solid #002060;">
            <div class="index-bottom-1-center-2-li" @click="checkChange('aoc值班', 'aoc_duty_data')">AOC值班</div>
            <div class="index-bottom-1-center-2-li" @click="dialogChange('aoc值班', 'aoc_duty_data')">{{
      dataObj['aoc_duty_data'] }}</div>
            <div class="index-bottom-1-center-2-li" @click="checkChange('现场值班', 'scene_data')">现场值班</div>
            <div class="index-bottom-1-center-2-li" style="border-right: none;"
              @click="dialogChange('现场值班', 'scene_data')">{{ dataObj['scene_data'] }}</div>
          </div>
        </div>
        <div class="index-bottom-1-bottom">
          <div class="index-bottom-1-bottom-top li">
            <div class="index-bottom-1-bottom-top-li" style="border-right: 2px solid #999;" @click="checkChange('本月处突情况', 'emergency_data')">近一周处突情况</div>
            <div class="index-bottom-1-bottom-top-li" style="white-space:normal;" @click="checkChange('下一日运行预判情况', 'situation_data')">下一日运行预判情况
            </div>
          </div>
          <div class="index-bottom-1-bottom-bottom">
            <div class="index-bottom-1-bottom-bottom-li" style="border-right: 2px solid #999;"
              @click="dialogChange('本月处突情况', 'emergency_data')">{{ dataObj['emergency_data'] }}</div>
            <div class="index-bottom-1-bottom-bottom-li" @click="dialogChange('下一日运行预判情况', 'situation_data')">{{
      dataObj['situation_data'] }}</div>
          </div>
        </div>
      </div>
      <div class="index-bottom-2">

        <div class="index-bottom-2-2">
          <div class="index-bottom-2-2-left">综合运输</div>
          <div class="index-bottom-2-2-center">
            <div class="li" style="border-right: 2px solid #999;" @click="dialogChange('本月加减分', 'minus_points_data')">{{
      dataObj['minus_points_data'] }}</div>
            <div class="li" @click="dialogChange('年度得分', 'annual_score_data')">{{ dataObj['annual_score_data'] }}</div>
          </div>
          <div class="index-bottom-2-2-center">
            <div class="li" @click="checkChange('本月加减分','minus_points_data')">本月加减分</div>
            <div class="li" @click="checkChange('年度得分','annual_score_data')">年度得分</div>
          </div>
        </div>
        
        <div class="index-bottom-2-1">
          <div class="li_file" style="position: relative;">
            <input id="file" class="upload" type="file" accept=".xls,.xlsx" @change="readExcel($event, 2)" />
            <div class="add">
              <p>导入</p>
            </div>
          </div>
          <centerLeft2 />
        </div>
        <!-- <div class="index-bottom-2-2">
          <div class="index-bottom-2-2-left">重点项目</div>
          <div class="index-bottom-2-2-center">
            <div class="index-bottom-2-2-center-li" style="background: #c00000;"
              @click="checkChange('重点项目一', 'project_one_data')"></div>
            <div class="index-bottom-2-2-center-li" style="background: #ffff00;"
              @click="checkChange('重点项目二', 'project_two_data')"></div>
            <div class="index-bottom-2-2-center-li" style="background: #92d050;"
              @click="checkChange('重点项目三', 'project_three_data')"></div>
          </div>
          <div class="index-bottom-2-2-right">
            <div class="index-bottom-2-2-right-li" style="border-bottom: 2px solid #999;"
              @click="dialogChange('重点项目一', 'project_one_data')">{{ dataObj['project_one_data'] }}</div>
            <div class="index-bottom-2-2-right-li" style="border-bottom: 2px solid #999;"
              @click="dialogChange('重点项目二', 'project_two_data')">{{ dataObj['project_two_data'] }}</div>
            <div class="index-bottom-2-2-right-li" @click="dialogChange('重点项目三', 'project_three_data')">{{
      dataObj['project_three_data'] }}</div>
          </div>
        </div> -->

        

        <div class="index-bottom-2-3">
          <div class="index-bottom-2-3-left">
            <div class="index-bottom-2-3-left-top">公寓楼情况</div>
            <div class="index-bottom-2-3-left-bottom">
              <div class="index-bottom-2-3-left-bottom-li" style="border-bottom: 2px solid #999;"
                @click="checkChange('日入住人数', 'guests_data')">日入住人数</div>
              <div class="index-bottom-2-3-left-bottom-li" style="border-bottom: 2px solid #999;"
                @click="dialogChange('日入住人数', 'guests_data')">{{ dataObj['guests_data'] }}</div>
              <div class="index-bottom-2-3-left-bottom-li" style="border-bottom: 2px solid #999;"
                @click="checkChange('房间使用', 'room_use_data')">房间使用</div>
              <div class="index-bottom-2-3-left-bottom-li" @click="dialogChange('房间使用', 'room_use_data')">{{
      dataObj['room_use_data'] }}</div>
            </div>
          </div>
          <div class="index-bottom-2-3-right">
            <div class="index-bottom-2-3-right-top">
              <div style="color: #FFF;font-size: 16px;cursor: pointer;">重点物料消耗情况</div>
              <div class="li_file_btn" style="position: relative;">
                <input id="file" class="upload" type="file" accept=".xls,.xlsx" @change="readExcel($event, 3)" />
                <div class="add">
                  <p>导入</p>
                </div>
              </div>
            </div>
            <centerLeft3 />
          </div>
        </div>
        <div class="index-bottom-2-4">
          <div class="index-bottom-2-4-left" @click="checkChange('本月检查复核情况', 'Review_situation')">本月检查<br />复核情况</div>
          <div class="index-bottom-2-4-right" @click="dialogChange('本月检查复核情况', 'Review_situation')">
            {{ dataObj['Review_situation'] }}
          </div>
        </div>
      </div>
      <div class="index-bottom-3">
        <div class="index-bottom-1-bottom">
          <div class="index-bottom-1-bottom-top li">
            <div class="index-bottom-1-bottom-top-li" style="white-space:normal;" @click="checkChange('航班协调情况', 'coordinate_data')">本月航班协调情况
            </div>
          </div>
          <div class="index-bottom-1-bottom-bottom">
            <div class="index-bottom-1-bottom-bottom-li" @click="dialogChange('航班协调情况', 'coordinate_data')">{{
      dataObj['coordinate_data'] }}</div>
          </div>
        </div>
        <div class="index-bottom-3-center">
          <div class="index-bottom-3-center-top">
            <div class="li_file_btn" style="position: relative;margin-top: 5px;">
              <input id="file" class="upload" type="file" accept=".xls,.xlsx" @change="readExcel($event, 4)" />
              <div class="add">
                <p>导入</p>
              </div>
            </div>
          </div>
          <centerLeft8 />
        </div>
        <div class="index-bottom-3-bottom">
          <div class="index-bottom-3-bottom-top-bottom">
            <div class="index-bottom-3-bottom-top-bottom-btn">
              <div class="li_file_btn" style="position: relative;">
                <input id="file" class="upload" type="file" accept=".xls,.xlsx" @change="readExcel($event, 5)" />
                <div class="add">
                  <p>导入</p>
                </div>
              </div>
            </div>
            <centerLeft6 />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import centerLeft2 from "./centerLeft2";
import centerLeft6 from "./centerLeft6";
import centerLeft3 from "./centerLeft3";
import centerLeft8 from "./centerLeft8";
import axios from 'axios'

// var password=""

// password=prompt('请输入密码(本网站需输入密码才可以进入):','');

// function custom_close()

// {

// window.opener=null;

// window.open('','_self');

// window.close();

// }

// if (password !='cua@admin')

// {

// custom_close();

// //加这一段是为了避免有些浏览器不支持关闭浏览器的js ,所以请求跳转到一个新页面！

// window.location.href='about:blank';

// }


export default {
  data() {
    return {
      loading: true,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      formLabelWidth: '120px',
      form: {
        name: '',
        text: '',
        params: '',
      },
      form1: {
        name: '',
        text: '',
        params: '',
        date: '',
        label: ''
      },
      tableData: [],
      dataObj: {
        quit_data: '',
        initiating_data: '',
        air_quit_data: '',
        air_initiating_data: '',
        hatch_data: '',
        miss_data: '',
        volume_data: '',
        volume_point_data: '',
        aeroplane_data: '',
        head_duty_data: '',
        clique_duty_data: '',
        mlion_duty_data: '',
        operations_manager_data: '',
        commander_data: '',
        aoc_duty_data: '',
        kawane_data: '',
        emergency_data: '',
        situation_data: '',
        project_one_data: '',
        project_two_data: '',
        project_three_data: '',
        guests_data: '',
        room_use_data: '',
        Review_situation: '',
        minus_points_data: '',
        annual_score_data: '',
        coordinate_data: '',
      }
    };
  },
  components: {
    centerLeft2,
    centerLeft6,
    centerLeft3,
    centerLeft8
  },
  async created() {
    await this.getList()
    await this.getScoreList()
    await this.getConsumList()
    await this.getStorageList()
    await this.getFlightList()
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 500);
  },
  methods: {
    getTime() {
      const now = new Date();
      const year = now.getFullYear() + '-'
      const month = ('0' + (now.getMonth() + 1)).slice(-2) + '-'
      const day = ('0' + now.getDate()).slice(-2);
      return year + month + day
    },
    logout() {
    localStorage.removeItem('isLogin')
    this.$router.push('/login')
    this.$message.success('已退出登录')
  },
    // 获取综合运输管理评分当日
    async getScoreList() {
      await axios({
        url: `http://115.190.8.169:5000/get_score_data?today_time=${this.getTime()}`,
        method: 'GET'
      }).then(res => {
        if (res.data != '网络错误' && res.data.length) {
          this.$store.commit('saveScoreList', res.data)
        }
      })
    },
    // 获取物料消耗情况
    async getConsumList() {
      await axios({
        url: `http://115.190.8.169:5000/get_consum_data?today_time=${this.getTime()}`,
        method: 'GET'
      }).then(res => {
        if (res.data != '网络错误' && res.data.length) {
          this.$store.commit('saveConsumList', res.data)
        }
      })
    },
    // 获取物料消耗情况
    async getStorageList() {
      await axios({
        url: `http://115.190.8.169:5000/get_storage_data?today_time=${this.getTime()}`,
        method: 'GET'
      }).then(res => {
        if (res.data != '网络错误' && res.data.length) {
          this.$store.commit('saveStorageList', res.data)
        }
      })
    },
    // 获取重点航班情况
    async getFlightList() {
      await axios({
        url: `http://115.190.8.169:5000/get_flight_data?today_time=${this.getTime()}`,
        method: 'GET'
      }).then(res => {
        if (res.data != '网络错误' && res.data.length) {
          this.$store.commit('saveFlightList', res.data)
        }
      })
    },
    async readExcel(e, num) {
      // 读取表格文件
      let that = this;
      const files = e.target.files;
      if (files.length <= 0) {
        return false;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.$message({
          message: "上传格式不正确，请上传xls或者xlsx格式",
          type: "warning"
        });
        return false;
      } else {
        // 更新获取文件名
        that.upload_file = files[0].name;
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          that.dataObj = []
          const data = ev.target.result;
          const workbook = XLSX.read(data, { type: "binary" });
          const wsname = workbook.SheetNames[num]; //取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //生成json表格内容
          var url = ''
          if(num == 2){
            url = 'http://115.190.8.169:5000/add_score'
          }else if(num == 3){
            url = 'http://115.190.8.169:5000/add_consum'
          }else if(num == 4){
            url = 'http://115.190.8.169:5000/add_storage'
          }else if(num == 5){
            url = 'http://115.190.8.169:5000/add_flight'
          }
          axios({
            url: url,
            method: 'POST',
            data: {today_time: this.getTime(),arrData: ws}
          }).then(res => {
            if (res.data != '网络错误') {
              if(num == 2){
                this.getScoreList()
              }else if(num == 3){
                this.getConsumList()
              }else if(num == 4){
                this.getStorageList()
              }else if(num == 5){
                this.getFlightList()
              }
              setTimeout(() => {
                this.getList()
              }, 10);
              this.$message.success(res.data);
            } else {
              this.$message.error(res.data);
            }
          })
        } catch (e) {
          return false;
        }
        e.target.value = null
      };

      fileReader.readAsBinaryString(files[0]);
    },
    async getList() {
      await axios({
        url: `http://115.190.8.169:5000/get_wactch_data?today_time=${this.getTime()}`,
        method: 'GET'
      }).then(res => {
        if (res.data != '网络错误' && res.data['id']) {
          this.dataObj = res.data
        }
      })
    },
    dialogFormVisibleChange() {
      this.dataObj[this.form.params] = this.form.text
      this.dataObj['today_time'] = this.getTime()
      axios({
        url: `http://115.190.8.169:5000/add_wactch_data`,
        method: 'POST',
        data: this.dataObj,
      }).then(res => {
        if (res.data != '网络错误') {
          this.dialogFormVisible = false
          this.$message.success(res.data);
          this.getList()
        } else {
          this.$message.error(res.data);
        }
      })
    },
    checkChange(name, params) {
      this.form1.date = params
      this.form1.label = name
      axios({
        url: `http://115.190.8.169:5000/get_single_data`,
        method: 'GET',
      }).then(res => {
        if (res.data != '网络错误' && res.data.length) {
          this.tableData = res.data
          this.form1.name = name + '--历史记录'
          this.dialogFormVisible1 = true
        }
      })

    },
    dialogChange(name, params) {
      this.form.text = this.dataObj[params]
      this.form.name = name
      this.form.params = params
      this.dialogFormVisible = true

    }
  },
};
</script>

<style lang="scss">
@import "../assets/scss/index.scss";

.li_file {
  position: relative;
  position: absolute;
  top: 12px;
  width: 80px;
  height: 25px;
  font-size: 14px;
  //导入左右距离
  margin-left: 78%;
  display: inline-block;
  margin-right: 25px;
  text-align: center;
  vertical-align: middle;
  box-shadow: 0px 0px 8px 1px rgba(0, 123, 229, 0.16);
  cursor: pointer;

  &:hover {
    cursor: pointer;
  }

  .upload {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    cursor: pointer;

    &:hover {
      cursor: pointer;
    }
  }

  .add {
    display: block;
    background-color: #F8F8F8;
    color: #666;
    padding: 8px 0;
  }

  .li_file:hover .add {
    background-color: #3594F4;
    color: #ffffff;
  }

  .add .iconfont {
    padding: 10px 0;
    font-size: 40px;
  }
}

.li_file_btn {
  position: relative;
  position: absolute;
  z-index: 9;
  margin-top: -.1rem;
  width: 80px;
  height: 25px;
  font-size: 14px;
  margin-left: 8px;
  display: inline-block;
  margin-right: 25px;
  text-align: center;
  vertical-align: middle;
  box-shadow: 0px 0px 8px 1px rgba(0, 123, 229, 0.16);
  cursor: pointer;

  &:hover {
    cursor: pointer;
  }

  .upload {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    cursor: pointer;

    &:hover {
      cursor: pointer;
    }
  }

  .add {
    display: block;
    background-color: #F8F8F8;
    color: #666;
    padding: 8px 0;
  }

  .li_file:hover .add {
    background-color: #3594F4;
    color: #ffffff;
  }

  .add .iconfont {
    padding: 10px 0;
    font-size: 40px;
  }
}

.li {
  line-height: 40px;
  cursor: pointer;
}

.index {
  

  width: 100vw;
  height: 100vh;
  overflow: hidden;
  cursor: pointer;

  .index-top {
    position: relative;
    height: 7%;
    border: 5px solid #002060;
    font-size: 24px;
    color: #002060;
    font-weight: bold;

    .index-top-left {
      position: absolute;
      padding: 12px 70px;
      left: 10%;
      top: 50%;
      transform: translate(-50%, -50%);
      // border: 2px solid #999;
    }

    .index-top-right {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
  }

    .index-top-center {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .index-bottom {
    display: flex;
    height: 93%;

    .index-bottom-1 {
      width: calc(100vw/3);
      border: 5px solid #002060;
      border-top: none;
      

      .index-bottom-1-top {
        
        .index-bottom-1-top-1 {
          padding-left: 33%;
          border-bottom: 2px solid #999;
          font-size: 20px;
          color: #000;
          font-weight: bold;
          
        }

        .index-bottom-1-top-2 {
          display: flex;

          .index-bottom-1-top-2-li {
            width: 25%;
            border-bottom: 2px solid #999;
            border-right: 2px solid #999;
            font-size: 16px;
            color: #000;
            font-weight: bold;
            text-align: center;
          }
        }

        .index-bottom-1-top-3 {
          display: flex;

          .index-bottom-1-top-3-li {
            width: 50%;
            font-size: 16px;
            color: #000;
            font-weight: bold;
            text-align: center;
            border-bottom: 2px solid #999;
            border-right: 2px solid #999;
          }
        }

        .index-bottom-1-top-4 {
          display: flex;
          // border-bottom: 10px solid #002060;

          .index-bottom-1-top-4-li {
            width: 50%;
            font-size: 16px;
            color: #000;
            font-weight: bold;
            text-align: center;
            border-bottom: 2px solid #999;
            border-right: 2px solid #999;
          }
        }
      }

      .index-bottom-1-center {
        .index-bottom-1-center-1 {
          border-bottom: 2px solid #999;
          font-size: 15px;
          display: flex;
          border-bottom: 2px solid #999;

          .index-bottom-1-center-1-li-left {
            width: 50%;
            text-align: center;
            font-size: 16px;
            color: #000;
            font-weight: bold;
            border-right: 2px solid #999;
          }

          .index-bottom-1-center-1-li-right {
            width: 50%;
            text-align: center;
            font-size: 16px;
            color: #000;
            font-weight: bold;
          }
        }

        .index-bottom-1-center-2 {
          display: flex;

          .index-bottom-1-center-2-li {
            width: 25%;
            border-bottom: 2px solid #999;
            border-right:2px solid #999;
            font-size: 16px;
            color: #0e1222;
            font-weight: bold;
            text-align: center;
          }
        }

        .index-bottom-1-center-3 {
          display: flex;

          .index-bottom-1-center-3-li {
            width: 50%;
            font-size: 16px;
            color: #0e1222;
            font-weight: bold;
            text-align: center;
            border-bottom: 2px solid #999;
            border-right: 2px solid #999;
          }
        }
      }

      .index-bottom-1-bottom {
        .index-bottom-1-bottom-top {
          display: flex;
          border-bottom: 2px solid #999;

          .index-bottom-1-bottom-top-li {
            width: 50%;
            font-size: 16px;
            color: #220e0e;
            font-weight: bold;
            text-align: center;

          }
        }

        .index-bottom-1-bottom-bottom {
          display: flex;
          flex: 1;
          height: 100vh;

          .index-bottom-1-bottom-bottom-li {
            display: flex;
            justify-content: left;
            text-align: justify;
            box-sizing: border-box;
            width: 50%;
            padding-left: 5px;
            padding-right:5px;
            line-height: 15px;
            font-size: 13px;
            white-space:pre-wrap;
            
            // font-weight: bold;
          }
        }
      }
    }

    .index-bottom-2 {
      width: calc(100vw/3);
      border: 5px solid #002060;
      border-left: none;
      border-top: none;

      .index-bottom-2-1 {
        position: relative;
        height: 34.5%;
        border-bottom: 2px solid #002060;


      }

      // .index-bottom-2-2 {
      //   z-index: 10;
      //   display: flex;
      //   height: 15%;

      //   .index-bottom-2-2-left {
      //     display: flex;
      //     align-items: center;
      //     justify-content: center;
      //     width: 20%;
      //     font-size: 18px;
      //     font-weight: bold;
      //   }

      //   .index-bottom-2-2-center {
      //     width: 30%;

      //     .index-bottom-2-2-center-li {
      //       height: 33.33%;
      //     }
      //   }

      //   .index-bottom-2-2-right {
      //     width: 50%;
          

      //     .index-bottom-2-2-right-li {
      //       display: flex;
      //       align-items: center;
      //       box-sizing: border-box;
      //       height: 33.33%;
      //       padding-left: 50%;
      //       font-size: 16px;
      //       font-weight: bold;
          
      //     }
      //   }
      // }
            .index-bottom-2-2 {
        // z-index: 10;
        // display: flex;
        height: 15%;

        .index-bottom-2-2-left {
          line-height: 0.5rem;
          border-bottom: 2px solid #999;
          text-align: center;
          font-size: 20px;
          font-weight: bold;
        }

        .index-bottom-2-2-center {
          display: flex;
          height: 0.55rem;
          border-bottom: 2px solid #999;
          .li {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            width: 50%;
            text-align: center;
            font-size: 20px;
            font-weight: bold;
          }
          
        .index-bottom-2-2-right {
          display: flex;
          height: 5.2rem;
          // border-bottom: 2px solid #999;

          .index-bottom-2-2-right-li {
            line-height: 1.5rem;
            width: 50%;
            text-align: center;
            font-size: 20px;
            font-weight: bold;
          }
         }
        }
      }



      
      .index-bottom-2-3 {
        display: flex;
        padding: 40px 0;
        height: 35%;
        font-weight: bold;
        background: #002060;

        .index-bottom-2-3-left {
          width: 30%;

          .index-bottom-2-3-left-top {
            color: #FFF;
            font-size: 16px;
            text-align: center;
          }

          .index-bottom-2-3-left-bottom {
            margin-top: 15px;
            background: #FFF;
            border: 2px solid #999;

            .index-bottom-2-3-left-bottom-li {
              font-size: 16px;
              
              text-align: center;
              line-height: 40px;
              height: 40px;
            }
          }
        }

        .index-bottom-2-3-right {
          width: 70%;
          .index-bottom-2-3-right-top{
            display: flex;
            justify-content: space-between;
          }
        }
      }

      .index-bottom-2-4 {
        height: 15.5%;
        display: flex;
        align-items: center;
        

        .index-bottom-2-4-left {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 20%;
          font-weight: bold;
          text-align: center;
          font-size: 18px;
          line-height: 26px;
          border-right: 2px solid #999;
          height: 100%;
        }

        .index-bottom-2-4-right {
          padding-left: 10px;
          display: flex;
          align-items: center;
          width: 80%;
          line-height: 26px;
          font-size: 13px;
          text-align: center;
          height: 100%;
        }
      }
    }

    .index-bottom-3 {
      width: calc(100vw/3);
      border: 5px solid #002060;
      border-left: none;
      border-top: none;

      .index-bottom-1-bottom {
        .index-bottom-1-bottom-top {
          display: flex;
          border-bottom: 2px solid #999;

          .index-bottom-1-bottom-top-li {
            width: 100%;
            font-size: 20px;
            color: #220e0e;
            font-weight: bold;
            text-align: center;

          }
        }

        .index-bottom-1-bottom-bottom {
          display: flex;
          flex: 1;
          height: 24vh;

          .index-bottom-1-bottom-bottom-li {
            display: flex;
            justify-content: left;
            text-align: justify;
            box-sizing: border-box;
            width: 100%;
            padding-left: 5px;
            padding-right:5px;
            line-height: 20px;
            font-size: 20px;
            white-space:pre-wrap;
            
            // font-weight: bold;
          }
        }
      }

      .index-bottom-3-center {
        position: relative;
        box-sizing: border-box;
        padding: 0 20px;
        box-sizing: border-box;
        border-bottom: 0px solid #002060;
        border-top: 5px solid #002060;
        height: 30%;
        background: #0d1120;
        .index-bottom-3-center-top{
          position: absolute;
          right: 0;
          top: 0;
          display: flex;
          justify-content: space-between;
        }
      }

      .index-bottom-3-bottom {
        position: relative;
        box-sizing: border-box;
        padding: 15px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 40%;
        background: #0d1120;

        .index-bottom-3-bottom-top-bottom{
          
          .index-bottom-3-bottom-top-bottom-btn{
            position: absolute;
            top: .35rem;
            right: 0;
          }
        }
      }
    }
  }
}
</style>